<template>
  <el-dialog title="证书信息" :visible.sync="visible" :before-close="handleClose" width="800px">

    <el-tabs v-model="activeName">
      <el-tab-pane label="基本信息" name="basic">
        <div class="ta-l tab-box">
          <el-row style="width: 100%;" class="mt10 mb10" v-if="signedInfo.eseal">
            <el-col :span="4">使用者：</el-col>
            <el-col :span="20">{{ signedInfo.eseal.esID }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">有效时间：</el-col>
            <el-col :span="20">
              有效起止日：{{ signedInfo.cert.notBefore }} 到 {{ signedInfo.cert.notAfter }}
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="详细信息" name="detailed">
        <div class=" ta-l tab-box">
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">版本：</el-col>
            <el-col :span="20">{{ signedInfo.cert.version }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">序列号：</el-col>
            <el-col :span="20">{{ signedInfo.cert.serialNumber }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">颁发者：</el-col>
            <el-col :span="20">{{ signedInfo.cert.issuer }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">使用者：</el-col>
            <el-col :span="20">{{ signedInfo.cert.subject }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">有效期：</el-col>
            <el-col :span="20">
              有效起止日：{{ signedInfo.cert.notBefore }} 到 {{ signedInfo.cert.notAfter }}
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="声明" name="statement">
        <div class="flex-r-start ta-l tab-box">
          验证电子印章的文档需要使用独立的第三方服务提供商提供的数字证书相关服务。 对电子印章文档、创建电子印章文档的证书及相关服务，由第三方服务提供商来保障。
          请详阅颁发者证书信息。
        </div>
      </el-tab-pane>
    </el-tabs>

  </el-dialog>
</template>

<script>

export default {
  name: "certificateInformation",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    signedInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeName: 'basic'
    };
  },
  methods: {
    // 关闭抽屉
    handleClose() {
      this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-tabs__content {
  display: flex;
  justify-content: flex-start;
}

.tab-box {
  height: 400px;
  width: 752px;
  font-size: 14px;
}
</style>
